module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "ct",
    attrs: {
      "id": "d7e211725"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/Lema_9781418514020_epub_c15_r1#Anch00525",
      "id": "Anch0047"
    }
  }, [_vm._v("CHAPTER 2"), _c('br'), _vm._v(" That Man Matters ")])]), _vm._v(" "), _c('p', {
    staticClass: "tx1",
    attrs: {
      "id": "d7e212525"
    }
  }, [_c('b', [_vm._v("I still remember when Holly, ")]), _vm._v("my oldest child, was born. My wife and I were in the delivery room, and I was working hard to be the world’s best labor coach.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e214025"
    }
  }, [_vm._v("I watched Sande squirm as her stomach was twisted by yet another contraction. “Everything’s okay,” I encouraged her, holding her hand as she lay there.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e215625"
    }
  }, [_vm._v("“Okay?!” She half yelled, half grunted. “Listen, buddy, things may be okay "), _c('i', [_vm._v("up there, ")]), _vm._v("but I assure you they’re not even close to being okay "), _c('i', [_vm._v("down here!”")])]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e217325"
    }
  }, [_vm._v("Sande had a gift for being acutely aware that she was the only one in the room experiencing pain.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e218625"
    }
  }, [_vm._v("Secretly, I suppose I thought a boy would be nice. I liked to hunt and fish in those days, and I love sports. But all of that was wiped out as soon as Holly made her entrance into the world. Holding that little girl was the most awesome experience I’ve ever known, and I remember thinking to myself, "), _c('i', [_vm._v("She’s perfect. Absolutely perfect. ")]), _vm._v("I wouldn’t have changed the shape of her toes, the length of her body, and certainly not her gender. She was ideal just as she was.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e221926"
    }
  }, [_vm._v("Sande had miscarried twice before she got pregnant with Holly, which made Holly’s arrival all the more special. When we brought her home, I was well prepared. I had the house so hot you could have popped corn in the sink. No way was my little girl going to catch a cold!")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e223526"
    }
  }, [_vm._v("“But we really don’t want to cook her, do we, dear?” Sande pleasantly inquired.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e224926"
    }
  }, [_vm._v("It took me a while to become comfortable with this little creature.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e225426"
    }
  }, [_vm._v("The nurse had warned me to support her head, so I always made sure I scooped her up just so, fighting back morbid thoughts that if I forgot to do so, my little girl’s head would fall back into the crib like that of a poorly made doll.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e227326"
    }
  }, [_vm._v("I became overly fond of mirrors. Every five minutes or so, I casually held a small one under my sleeping daughter’s nose, and a huge smile covered my face when I saw the life-signaling cloud of breath cover the glass.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e228926"
    }
  }, [_vm._v("My daughter.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e229626"
    }
  }, [_vm._v("What I didn’t realize at the time was that this little girl would grow up all too quickly and one day look into my eyes and respond, “My daddy” with the same wistful, emotion-laden tone.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e231026"
    }
  }, [_vm._v("I wish there were some way I could get fathers to look away from their investment portfolios, step out of their offices, or get their heads out from under the hoods of their cars long enough to ruminate over the mystery of a father’s love for his daughter and a daughter’s love for her father. I believe a good percentage of a man’s ultimate happiness, meaning, and fulfillment lies in that relationship.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e233326"
    }
  }, [_vm._v("But men, brilliant beings that we are, are like the guy at the turn of the century who never turned on his faucet but instead dug a hole in his backyard, hoping to find water. What we want is right in front of us, but we go everywhere else in search of it, missing that precious little gem who waits patiently for our attention.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e235727"
    }
  }, [_vm._v("Fortunately, some of our nation’s most famous men are waking up to the fact that parenting can become a man’s most meaningful and challenging vocation. Let’s see if we can’t learn a thing or two from them.")]), _vm._v(" "), _c('p', {
    staticClass: "h3l",
    attrs: {
      "id": "d7e237227"
    }
  }, [_c('b', [_c('i', [_vm._v("The Next Challenge for Jordan and Johnson ")])])]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e237727"
    }
  }, [_vm._v("When Michael Jordan announced his retirement in January 1999, it made headlines around the world. A Milan, Italy, newspaper proclaimed: “Ciao, Jordan, You Will Always Be Air-Basketball!” In Tokyo, the headlines seemed apocalyptic: “Jordan Retires! Shock Felt Around the World!”")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e239627"
    }
  }, [_vm._v("Few basketball fans will ever forget many of the incredible plays that Jordan made, but I will always remember one in particular. It occurred during Game Two of the 1991 NBA Finals against the Los Angeles Lakers. His Airness drove down the center of the lane and went up for a right-handed layup. Immediately, Sam Perkins and A. C. Green came over to cover him. They had him smothered in midair, and it looked like the greatest basketball player of all time would be seriously embarrassed, stuffed without anywhere to go.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e243827"
    }
  }, [_vm._v("Instead, Jordan changed his plans in midair. He seemed to defy the law of gravity, hanging in the atmosphere long enough to double-clutch and transfer the ball from his right hand to his left.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e245427"
    }
  }, [_vm._v("It was a split second decision that caught the two defenders completely off guard. The ball gently bounced off the backboard and fell through the net. An uproarious bellow from the crowd followed a stunned silence. It was an amazing play.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e247328"
    }
  }, [_vm._v("Another startling move occurred several years later during an all-star game. Grant Hill was shooting a free throw as Jordan hung back on top of the key. For 99.99 percent of basketball players, the top of the key during a free throw is usually considered a defensive position.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e248928"
    }
  }, [_vm._v("But just as Hill let go of the ball, Jordan raced down the center of the key, beating all the players who were lined up right beside the basket, and took the ball off the rim, slamming it home without touching the ground.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e251028"
    }
  }, [_vm._v("Even Jordan seemed awed by this one. He smiled, wagged his head, and shrugged his shoulders as if to say, “Where did that come from? I don’t know any better than you.” He was six inches shorter than the centers and twenty feet farther from the ball, but the ball still ended up in his hands.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e252928"
    }
  }, [_vm._v("After such a spectacular and exciting career, you might think Jordan’s retirement would be, well, boring. Jordan addressed this during a press conference called to announce his retirement. He referred to the fact that some questioned whether he would hate retirement because it would lack the “challenge” he needed. Jordan was adamant.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e254728"
    }
  }, [_vm._v("“I dispute that,” he said.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e255428"
    }
  }, [_vm._v("What was the challenge he looked forward to, one that could measure up to the excitement of winning six NBA titles and countless individual records? Was it entering politics?")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e257428"
    }
  }, [_vm._v("No.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e258228"
    }
  }, [_vm._v("What about becoming a CEO, or once again entering a new professional sport?")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e259428"
    }
  }, [_vm._v("Absolutely not.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e260128"
    }
  }, [_vm._v("The challenge Michael Jordan looked forward to was . . . "), _c('i', [_vm._v("parenting.")])]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e260828"
    }
  }, [_vm._v("In 1998, a researcher sought to make a name for herself by publishing a book purporting that parents really don’t matter. According to her, peer influence and nature’s imprint will determine a child’s destiny, and there’s little a parent can do about it.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e263029"
    }
  }, [_vm._v("As a psychologist, it was inevitable that I’d be asked about this book—which I don’t want to dignify by mentioning its name. Apart from the fact that this woman didn’t even have the credentials to examine the literature she collated (there were no original studies, just a collection of other studies, and she has no background in the social sciences), it’s so easy to refute what this woman is suggesting.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e265329"
    }
  }, [_vm._v("“Let’s go down to the local prison,” I told one inquirer. “Let’s talk to the prisoners. You show me one inmate who had a mom and dad who honored each other and had a loving, respectful marriage. I doubt you’ll find one.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e266929"
    }
  }, [_vm._v("It almost pains me to have to remind parents of this, but the very act of parenting has come under so many assaults that it’s necessary: As a father, "), _c('i', [_vm._v("you make a difference")]), _vm._v(". It is not true that all parents can do is cross their fingers and hope for the best. We "), _c('i', [_vm._v("can ")]), _vm._v("help our children find their way in life. It is crucial that we do this.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e269729"
    }
  }, [_vm._v("Why don’t most men see parenting for the challenge that it is? One of the most difficult aspects is that fathering never stops. Whereas Michael Jordan had a halftime to recover from weariness and a season’s end to look forward to, there is no season’s end or halftime in parenting. There are no time-outs, either. Michael Mignard, dean of students at Meadow Creek Christian School in Andover, Minnesota, found this out when he was driving his kindergarten-age son to a doctor’s appointment.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e273429"
    }
  }, [_vm._v("“Dad,” his son said, “Erin saw you in your car at McDonald’s yesterday.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e274229"
    }
  }, [_vm._v("Mignard didn’t know who Erin was. But Erin had passed the news on to his son, and Mignard realized he was always on display, even when he wasn’t aware of it. It was a sobering realization."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/Lema_9781418514020_epub_c32_r1#d8",
      "id": "a8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("1")])])]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e276730"
    }
  }, [_vm._v("You might think that men would eagerly embrace such a challenge.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e277230"
    }
  }, [_vm._v("Aren’t we the ones who first tackled Mount Everest and the North Pole and sailed across wide seas to reach distant lands?")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e278230"
    }
  }, [_vm._v("Yet all too frequently, parenting—especially "), _c('i', [_vm._v("fathering")]), _vm._v("—receives the leftovers. After work, after golf, after the car gets fixed and the football game is over, then, if nothing else needs to be done, the father will make time for his children. Many men are missing out on the most fulfilling "), _c('i', [_vm._v("and most influential ")]), _vm._v("work they could ever do.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e281030"
    }
  }, [_vm._v("Miami football coach Jimmy Johnson saw the futility of the rat race in 1999, just after the Dolphins had been knocked out of the playoffs.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e281830"
    }
  }, [_vm._v("Near the end of 1998, Johnson’s mother died. There was a viewing the day before the funeral, which Jimmy wasn’t able to attend due to his responsibilities as head coach, but he noted with a voice chock-full of emotion that his sons had been there.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e283530"
    }
  }, [_vm._v("The experience tore him up, especially after the season was over and no fewer than five out of twenty-eight—almost 20 percent—of the head coaches were fired in two days. Johnson saw that he was in a grueling profession that demanded all but gave no loyalty in return.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e285430"
    }
  }, [_vm._v("“I hear coaches say they put their religion first, family second, and football third,” he said, “but they work at football fifteen or sixteen hours a day. They go to church one hour a week. And they spend a few hours with their families. That tells me where their attention is.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e287030"
    }
  }, [_vm._v("Jimmy had the excitement of coaching a very successful and historic franchise. He led a sure-to-be-Hall-of-Fame quarterback, Dan Marino.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e287830"
    }
  }, [_vm._v("He was convinced that he was “just a couple playmakers away” from winning a championship. But more than another Super Bowl ring, he desired increased time with those he loved, so he worked out a deal with his owner to bring in an assistant head coach to lighten the load.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e290031"
    }
  }, [_vm._v("“I’m not going to be here at midnight anymore,” the hard-charging Johnson promised."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/Lema_9781418514020_epub_c32_r1#d9",
      "id": "a9",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("2")])])]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e291331"
    }
  }, [_vm._v("Michael Jordan and Jimmy Johnson—the ideals of successful masculinity according to our culture—both sought a change that would make family a higher priority. Yet all across this country, many men are ignoring their kids to get what Jordan and Johnson have already experienced— and found wanting.")]), _vm._v(" "), _c('p', {
    staticClass: "h3l",
    attrs: {
      "id": "d7e293631"
    }
  }, [_c('b', [_c('i', [_vm._v("A Man’s Worth ")])])]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e294131"
    }
  }, [_vm._v("By 1986 Sande and I had three children, the youngest of whom was nine years old. Sande was forty-two and I was forty-four. My career was taking off; finances were comfortable; life was turning out perfectly. We were ready to move on.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e296331"
    }
  }, [_vm._v("Life was going too perfectly, as it turned out.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e297131"
    }
  }, [_vm._v("Sande and I were enjoying a steakhouse dinner when she slipped me a card signaling the end of my blissful complacency. My wife is an artsy type of person, and it was just like her to produce a homemade card.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e298631"
    }
  }, [_vm._v("I opened the envelope and read the front of the card: “Are you ready to change your vacation? Are you ready to change your sleeping habits?”")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e299431"
    }
  }, [_c('i', [_vm._v("What in the world is this? ")]), _vm._v("I thought. Was there a joke I was missing?")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e300231"
    }
  }, [_vm._v("“Turn it over,” Sande suggested.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e301231"
    }
  }, [_vm._v("I did so and read "), _c('i', [_vm._v("Merry Christmas! ")]), _vm._v("But it was the picture that caught my eye. There was Santa Claus holding a cute little baby with a toothless grin.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e303432"
    }
  }, [_vm._v("I looked at Sande and my mouth dropped open.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e304432"
    }
  }, [_vm._v("“Does this mean what I think it means?”")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e305132"
    }
  }, [_vm._v("It did.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e305832"
    }
  }, [_vm._v("Enter daughter number three, Hannah.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e306532"
    }
  }, [_vm._v("Five years later, once again thinking that our family was complete, forty-seven-year-old Sande surprised me for what was surely the last time.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e307632"
    }
  }, [_vm._v("On this occasion, I was even less charitable. “Give me something to kill. I’ll kill it right here,” I muttered under my breath. I was forty-nine years old! I quickly did the math and realized that when this baby grew up and entered high school, I’d be drooling over my walker during the PTA meetings.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e309732"
    }
  }, [_vm._v("But today, if you ask our youngest, Lauren, to complete the sentence “You are daddy’s little . . .”, ten to one she’ll say “gift from God.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e310732"
    }
  }, [_vm._v("Everything that Lauren and Hannah “disrupted” pales in comparison to what they’ve brought into my life, confirming to me once again that no matter what I do, I will never be more fulfilled than I am as the father of four daughters and one son.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e312332"
    }
  }, [_vm._v("When I walk through the front door, it doesn’t matter what Lauren and Hannah are doing. They can be in the middle of eating an ice cream sundae, watching the exciting conclusion of "), _c('i', [_vm._v("Little House on the ")]), _c('i', [_vm._v("Prairie")]), _vm._v(", or playing with their favorite friend; they’ll drop what they’re doing and make a mad dash to Dad.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e314732"
    }
  }, [_vm._v("These two little girls are so keyed in to the arrival of their father, they can’t wait to get their arms around me. They don’t care how much money I’ve made that day. They couldn’t care less how many books I’m selling, or whether two dozen or two thousand people showed up to hear me speak. The doctorate degree behind my name means absolutely nothing to them. I could be a high school dropout (which I very nearly was), and they’d feel the same way.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e317733"
    }
  }, [_vm._v("One of the saddest things I’ve witnessed is how so many men miss this unconditional love and acceptance because they fail to nurture one of the most precious relationships they’ll ever have. They spend all day fighting for respect at the office, wearing out the leather on their two-hundred-dollar pair of shoes, just to get the world to say, “That man matters.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e320033"
    }
  }, [_vm._v("Let me tell you something: "), _c('i', [_vm._v("If you have a daughter, you matter more ")]), _c('i', [_vm._v("than you’ll ever know. ")]), _vm._v("Every decision you make should take this into account. If you ever get tempted to dump your wife, do yourself a favor.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e321533"
    }
  }, [_vm._v("Hold your daughter in your lap, look into her eyes, then just try to tell her you’re going to leave. You can’t divorce your wife without making your daughter feel you’re divorcing her as well.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e322933"
    }
  }, [_vm._v("I don’t care who you are. Your company can replace you (and they will), but in your little girl’s eyes, there will always be just one of you.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e323733"
    }
  }, [_vm._v("Why expend all your energy outside the home for something that is so freely given inside? I know part of the answer. At precisely the time that most men are starting a young family, they’re also climbing a couple of rungs on the corporate ladder. The time they’re most needed at home is the time they’re pulled most strongly toward work.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e325533"
    }
  }, [_vm._v("It’s crunch time.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e326233"
    }
  }, [_vm._v("Pause just a moment and ask yourself: What’s really most important?")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e326733"
    }
  }, [_vm._v("Of all the things you do, what will make you matter most? Do your kids really need another ten thousand dollars? Or would they benefit more from a dad who makes it home in time for dinner more often?")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e328133"
    }
  }, [_vm._v("I do a lot of talking on radio and television shows—"), _c('i', [_vm._v("The View")]), _vm._v(", "), _c('i', [_vm._v("Oprah")]), _vm._v(",")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e329834"
    }
  }, [_c('i', [_vm._v("CNN, ")]), _vm._v("the "), _c('i', [_vm._v("Today Show")]), _vm._v(", "), _c('i', [_vm._v("Good Morning America, Focus on the Family. ")]), _vm._v("On one occasion, I brought one of my daughters with me to the studio.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e331734"
    }
  }, [_vm._v("After the first session, I stepped outside to get a cup of coffee, but my daughter wanted to hang around.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e332734"
    }
  }, [_vm._v("Thinking that nothing could possibly harm her, I left my daughter alone, and when I came back, I found that the host had decided it would be “fun” to put my seven-year-old daughter on the air—without my permission.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e334334"
    }
  }, [_vm._v("You want to see angry? The IRS could confiscate everything I own, and it wouldn’t even make it on the scale compared to how I felt about this parasite, this amoeba, this infectious disease who dared to mess with my daughter without checking with me first.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e335934"
    }
  }, [_vm._v("I got there just in time to hear him ask her, “What’s it like to have a father like yours? One that’s on television and radio all the time?”")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e336934"
    }
  }, [_vm._v("Krissy cut me to my knees with her response. “Oh, you don’t understand,” she said. “He’s just my daddy.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e338434"
    }
  }, [_vm._v("Everything that impressed that parasitic host meant nothing to my little Krissy. To her I was a waist to hug, a cheek to kiss, and two arms to enfold her. I’m a person to encourage her, a strong presence to guide her, a nurturer who will love her.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e340334"
    }
  }, [_vm._v("Yeah, I cried. Wouldn’t you? When it comes to my daughters, I’m the biggest wuss there is.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e341634"
    }
  }, [_vm._v("Because my two oldest daughters are now in their twenties, I’ve come full circle in many ways and have gained a perspective I’d like to pass on to a few of you dads. Remember that little girl Holly I told you about at the beginning of this chapter? I’ll never forget the day she went off to college. It shaped my priorities forever.")]), _vm._v(" "), _c('p', {
    staticClass: "h1",
    attrs: {
      "id": "d7e343935"
    }
  }, [_vm._v("“Now It’s My Turn”")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e344635"
    }
  }, [_vm._v("The day Holly went away to college, she just about ripped my heart out. We loaded up two cars and drove two and a half hours to Grove City College, about fifty miles from Pittsburgh, Pennsylvania. Though both cars were fully packed, they were emptied within five minutes, mostly by boys who seemed to be casting enough side glances at Holly to risk neck problems for the rest of their lives.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e346935"
    }
  }, [_vm._v("I wondered if strangling a college boy to make a point about the sanctity of my daughter would be considered self-defense.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e347935"
    }
  }, [_vm._v("The day was a whirlwind of helping Holly set up her room, going to parents’ meetings, and touring the campus. Finally I turned to Sande and said, “Well, we better get going.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e349535"
    }
  }, [_vm._v("“We can’t leave yet,” Sande protested. “I haven’t made Holly’s bed.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e350335"
    }
  }, [_vm._v("Remember, we were dropping Holly off at "), _c('i', [_vm._v("college, ")]), _vm._v("not preschool. But before I could argue, Sande shot me the look that husbands recognize to mean, “You better back off, chump.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e352535"
    }
  }, [_vm._v("Being a man of discretion, I backed off.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e353235"
    }
  }, [_vm._v("Five minutes later, the bed was made and there were no more excuses to stay. For the first time in almost two decades, one of our children would live under a different roof. Holly started to say good-bye, and I felt a lump the size of an elephant work its way up my throat.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e355035"
    }
  }, [_vm._v("“Don’t say good-bye here,” I pleaded with Holly. “Walk us out to the car.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e356035"
    }
  }, [_vm._v("I sort of stumbled to the parking lot, not at all liking what was going on, and watched as Sande and Holly said a few final words.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e357135"
    }
  }, [_vm._v("Sande was hugging Holly in a cradling manner, softly rocking our eighteen-year-old, almost as if she wanted one final moment with her little baby.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e359136"
    }
  }, [_vm._v("I purposefully kept my distance, afraid that if Holly approached me I’d break down on the spot and make a spectacle of myself. “Don’t you dare come over here,” I silently muttered. “Stay right where you are.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e360236"
    }
  }, [_vm._v("Of course, as soon as I said that, Holly broke from her mother’s arms and walked toward me. She put her arms around me and said, “I love you, Dad.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e361636"
    }
  }, [_vm._v("I held Holly close to me for a long time. She went to pull back, but I wouldn’t let go. The symbolism was too real, and all my self-defenses were obliterated.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e362936"
    }
  }, [_vm._v("I started sobbing profusely.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e363636"
    }
  }, [_vm._v("Holly looked up at me with astonishment. “Dad?” Her mouth dropped open. “What’s wrong? I’ve never seen you cry like that in my life!”")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e364736"
    }
  }, [_vm._v("I looked down and saw that my tears were falling on Holly’s “front.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e365236"
    }
  }, [_vm._v("It’s funny what you think about at life’s most tender moments. In this case, I was reminded that Holly has breasts. In a split second, my thoughts went back to when Holly was just ten years old and I found myself stepping on something that was lying on the floor.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e366936"
    }
  }, [_vm._v("I picked it up and looked at it in astonishment. At first glance it appeared to be a bra, so I assumed it belonged to my wife, yet clearly it was much too small for Sande. In amazement and great curiosity I carried that thing around the corner and called out to Sande, “Honey, what’s this?”")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e369636"
    }
  }, [_vm._v("“That’s Holly’s bra.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e370336"
    }
  }, [_vm._v("I looked at that thing again and shook my head. “My Holly has a bra?” Then I kind of chuckled. “This looks like it’s going to grow up someday and "), _c('i', [_vm._v("become ")]), _vm._v("a bra.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e372337"
    }
  }, [_vm._v("Holding my daughter in the parking lot, I kept thinking, "), _c('i', [_vm._v("You can’t be ")]), _c('i', [_vm._v("grown up. You’re still ten years old. No, you’re twenty and a half inches ")]), _c('i', [_vm._v("long, and I’m just bringing you home from the hospital, turning up the heat, ")]), _c('i', [_vm._v("and checking your breathing every ten minutes.")])]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e374137"
    }
  }, [_c('i', [_vm._v("This can’t be. We need more time together. I’m not ready to wake up on ")]), _c('i', [_vm._v("Saturday mornings and not see you in front of your cereal bowl. Will anybody ")]), _c('i', [_vm._v("else eat Cocoa Puffs?")])]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e375637"
    }
  }, [_vm._v("Then my testosterone kicked in. When men get choked up and emotional, we tend to shut down.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e376837"
    }
  }, [_vm._v("“Holly, you gotta go,” I said, turning her around and giving her a gentle nudge. She walked away from me in a straight line, never looking back.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e378637"
    }
  }, [_vm._v("“Holly, call us tonight, honey!” I called out.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e379437"
    }
  }, [_vm._v("Holly lifted her hand above her shoulder, like a politician waving off a reporter’s question, and disappeared into the dormitory without turning around.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e380937"
    }
  }, [_vm._v("I looked at Sande and said, “Let’s get out of here.” We drove in silence for twenty minutes, holding hands, thinking, grieving.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e382037"
    }
  }, [_vm._v("Everything within me screamed, “Flip a U-turn, Leman, and get that girl of yours out of there. Forget this college stuff. She belongs at home.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e383737"
    }
  }, [_vm._v("Somehow our car kept heading north and we made it back to Chautauqua Lake.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e384937"
    }
  }, [_vm._v("That night I lived for Holly’s phone call. When a ring broke the silence, I about tackled everyone trying to get to the phone. The call was for Krissy.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e386437"
    }
  }, [_vm._v("“Five minutes,” I told her. “Holly’s gonna call, and we don’t want to hold up the line.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e388038"
    }
  }, [_vm._v("Krissy knows when I’m not being fully rational, so she kept to her limit. I immediately checked for messages in case Holly had called while Krissy was on the line, but there were none.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e389838"
    }
  }, [_vm._v("I went back to the living room and waited.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e390538"
    }
  }, [_vm._v("“Holly knows I watch the evening news,” I said. “Maybe she’s waiting until it’s over.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e391738"
    }
  }, [_vm._v("Eleven-thirty came and I waited some more.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e392438"
    }
  }, [_vm._v("And I went to bed.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e393238"
    }
  }, [_vm._v("Holly never called.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e393938"
    }
  }, [_vm._v("The next day, Monday, I was home early. Clearly, Holly had gotten hung up the night before, I thought, but she’d call us tonight. As a former dean of students, I knew enough not to call her, but oh, how I couldn’t wait for her to call me.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e395738"
    }
  }, [_vm._v("Up till that moment, I had never in my life looked forward to a phone ringing, but that night and the next six days there wasn’t a sweeter—and then sadder—sound.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e397038"
    }
  }, [_vm._v("The phone rang all right, but Holly wasn’t behind a single call.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e397738"
    }
  }, [_vm._v("The next Sunday—seven days after we had dropped her off—Holly finally called. I was excited, but I told myself to cool it lest I scare her off. Instead, I let her ramble on about freshman week, the campus, and how beautiful Pittsburgh is. Toward the end of the conversation, she turned a little melancholy. Finally I couldn’t help myself.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e399638"
    }
  }, [_vm._v("“Holly,” I said. “I’ve got to ask you a question. When you were walking away from us last Sunday, what were you thinking about?”")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e400938"
    }
  }, [_vm._v("“Daddy,” she said—and I immediately noticed she didn’t say Dad— “It’s funny you should mention that, because I was thinking about it all this week. What was going through my mind was, "), _c('i', [_vm._v("Well, Mom and Dad ")]), _c('i', [_vm._v("really brought me up right, and now it’s my turn to go do it.”")])]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e402738"
    }
  }, [_c('i', [_vm._v("Now it’s my turn. ")]), _vm._v("That’s what fathering is all about—giving our kids their turn. The greatest accomplishment I could ever undertake is preparing the next generation to take over their world. Any sacrifice I had made on Holly’s behalf, at that moment, seemed so insignificant to the woman she had become.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e405339"
    }
  }, [_vm._v("I got a letter from Holly a few days later. Since I know I could never survive reading it at a seminar, I thought I’d put it in this book.")]), _vm._v(" "), _c('p', {
    staticClass: "ext",
    attrs: {
      "id": "d7e406339"
    }
  }, [_vm._v("Dad,")]), _vm._v(" "), _c('p', {
    staticClass: "ext1",
    attrs: {
      "id": "d7e406839"
    }
  }, [_vm._v("I hated saying goodbye to you. I didn’t think it’d be that hard for either of us—especially you. I really miss you, Dad. It’s weird, these past two weeks I’ve felt closer to you than ever just because I saw how much you were going to miss me.")]), _vm._v(" "), _c('p', {
    staticClass: "ext1",
    attrs: {
      "id": "d7e408439"
    }
  }, [_vm._v("I miss waking up and reading the newspaper with you the most. I "), _c('i', [_vm._v("loved ")]), _vm._v("having you all to myself, early in the morning, sitting on the counter and reading and discussing the paper with you. I "), _c('i', [_vm._v("really ")]), _vm._v("liked the way you handed me the “Life” and “Dear Abby” sections before I asked for them. I’ll bet you miss me walking in on you when you’re taking a shower!")]), _vm._v(" "), _c('p', {
    staticClass: "ext1",
    attrs: {
      "id": "d7e411339"
    }
  }, [_vm._v("Thanks for all your encouragement, Dad. Whenever I feel discouraged, I think of all the times you wanted to quit but didn’t. I’m very proud of you and all you’ve accomplished.")]), _vm._v(" "), _c('p', {
    staticClass: "ext1",
    attrs: {
      "id": "d7e412839"
    }
  }, [_vm._v("Dad, I love you so much. You’re the best dad in the world! Thank you for giving me an education.")]), _vm._v(" "), _c('p', {
    staticClass: "ext1",
    attrs: {
      "id": "d7e413839"
    }
  }, [_vm._v("Never forget how much you mean to me.")]), _vm._v(" "), _c('p', {
    staticClass: "ext20",
    attrs: {
      "id": "d7e414539"
    }
  }, [_vm._v("I love you!"), _c('br'), _vm._v(" Holly")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e415739"
    }
  }, [_vm._v("Years later, I told the story of my and Holly’s parting at a seminar Holly happened to be attending. Afterward, Holly came up to me and said, “You know, there’s something missing in your story.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e417340"
    }
  }, [_vm._v("“What’s that?”")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e418040"
    }
  }, [_vm._v("“You know why I didn’t turn around?” she asked.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e418740"
    }
  }, [_vm._v("“No. Why?”")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e419440"
    }
  }, [_vm._v("“Because I was crying, and I didn’t want you to know I was scared.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e419940"
    }
  }, [_vm._v("Holly knew she was loved. She knew she had been given a good start. And now she wanted me to be proud of her. She didn’t want me to know she was afraid because she knew it was time for her to step out on her own.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e421640"
    }
  }, [_vm._v("Holly may have been scared, but she did fine. She went on to become an attendant in the homecoming court her freshman year and in her senior year as homecoming queen. If I’ve given you the impression I came anywhere near to being a perfect father, let me tell you the mistake I made when Holly was crowned queen at Grove City College.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e424040"
    }
  }, [_vm._v("I had accepted a Parent Talk Seminar with Randy Carlson, long before we knew that Holly would be a queen candidate.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e425340"
    }
  }, [_vm._v("Once Holly had been chosen as a finalist, I told Randy, “Hey, I need to leave the seminar early so I can attend the homecoming ceremonies at Grove City College. Holly is running for queen, and at a small college like this, there’s a big to-do. A parade. The homecoming game.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e426940"
    }
  }, [_vm._v("The dance. I can’t miss it.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e427740"
    }
  }, [_vm._v("Randy understood how I felt, but several hundred people had already signed up for our seminar, which was to include both of us for the entire time. “How can I tell them you’ll only be here for a day?” he asked.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e429040"
    }
  }, [_vm._v("Rather than stick to my guns, I stood behind my former commitment.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e429540"
    }
  }, [_vm._v("Then Holly was elected Homecoming Queen, and I was not there to share that special event with her.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e430540"
    }
  }, [_vm._v("I wish I had said, “I am leaving anyway,” but I didn’t.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e431641"
    }
  }, [_vm._v("I know Holly wishes I had done so.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e432341"
    }
  }, [_vm._v("I’m certainly proud of that honor and everything else she’s done. She went through commencement with no fewer than six job offers on the table. Today, she heads up the English department at a local high school.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e433941"
    }
  }, [_vm._v("She’s making the most of her turn.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e434641"
    }
  }, [_vm._v("It’s my daughters’ and my son’s turn now, and I feel prouder about giving them a good start than anything else I’ve ever done. I don’t have to prove that I count; I just need to look in the right direction and I’m immediately reminded that I do.")]), _vm._v(" "), _c('p', {
    staticClass: "h1",
    attrs: {
      "id": "d7e436241"
    }
  }, [_vm._v("Parting Shots")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e436841"
    }
  }, [_vm._v("I don’t know how to say this without just coming out with it, so here it is: My wife is a looker. Men, if she walked into the room, you’d notice her.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e438141"
    }
  }, [_vm._v("Twice.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e438841"
    }
  }, [_vm._v("Which means that whenever she’s standing next to me, men invariably let their eyes roam from me to her, and back to me, and I can read the wheels turning in their minds: "), _c('i', [_vm._v("How did a guy like him get ")]), _c('i', [_vm._v("a woman like her?")])]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e440641"
    }
  }, [_vm._v("I’m not sure that men ever outgrow the need to be wanted by women.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e441141"
    }
  }, [_vm._v("But often we focus on being wanted for the wrong things.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e441841"
    }
  }, [_vm._v("We think if we make enough money, we’ll be wanted. And you know what? We will be. By materialistic women. Or we imagine that if we can have the abdomen and chest of a twenty-five-year-old when we’re fifty-five, women will take notice. But they’ll be shallow women who care about such things.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e444042"
    }
  }, [_vm._v("It is far more meaningful to be appreciated for our character. I can’t tell you how many women come up to me after my seminars, tears streaming mascara down their faces, whispering, “I wish you could be my dad.” It’s very often a grown woman who says this. She’d never imagine me as a husband—I’m not a looker—but boy, would she like to go back and have me for a dad.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e446342"
    }
  }, [_vm._v("Bob Carlisle, who wrote and recorded the popular song “Butterfly Kisses,” has had the same experience. In his book by the same title, Bob wrote, “I get a lot of mail from young girls who try to get me to marry their moms. That used to be a real chuckle because it’s so cute, but then I realized they don’t want a romance for Mom. They want the dad who is in that song, and that just kills me.”"), _c('sup', [_c('span', {
    attrs: {
      "href": "#/Lema_9781418514020_epub_c32_r1#d10",
      "id": "a10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("3")])])]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e448842"
    }
  }, [_vm._v("That’s how deep the father hunger is in a woman’s heart. This isn’t just sentimental wishing. Dr. Kimberlyn Rachael Anne Leary did a doctoral dissertation on a father’s impact on his daughter during adolescence. Even when the father was perceived to be distant and less involved, the adolescent daughter viewed her father as “larger than life” and as “having considerable psychological presence” in her life."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/Lema_9781418514020_epub_c32_r1#d11",
      "id": "a11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("4")])])]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e452142"
    }
  }, [_vm._v("At my funeral I want just two things. First, a lot of crying would be nice; wailing would be preferable. Let the whole town hear that at least a few people are sad to see Cubby Leman go into an eternal hibernation as far as this world is concerned.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e454242"
    }
  }, [_vm._v("But second, I’d like my wife to say I was a good husband and a good father.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e455342"
    }
  }, [_vm._v("Don’t bury me with my books. For crying out loud, don’t even "), _c('i', [_vm._v("think ")]), _vm._v("about putting my diplomas in my coffin. Let me be buried with the memories of those I love the most. Let me live on in the sparkle of my daughters’ eyes and the carefully planted confidence of a grown son.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e457443"
    }
  }, [_vm._v("I don’t need a Super Bowl ring, a fifty-year watch, or a portfolio the size of Warren Buffett’s. I just want a family who misses me, grandkids who remember me, and a wife who needs and respects me.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e459343"
    }
  }, [_vm._v("If that comes true, I’ll know I’ve mattered—and I’ll never care what the rest of the world thinks.")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-9c4c9a0e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Lema_9781418514020_epub_c18_r1.vue
// module id = 78
// module chunks = 0